import { AxiosInstance } from 'axios'
import { BaseHTTP } from './base.http'

export class FacturaAPI {
  private http!: AxiosInstance

  constructor() {
    this.http = BaseHTTP.getInstance().http
  }

  emitirFactura(bussinesId, xUseDefaults, payload) {
    console.log('emitirFactura', { bussinesId, xUseDefaults, payload })
    const path = `v1/factura/emitir/${bussinesId}/${xUseDefaults}`
    // const path = `http://localhost:8000/v1/factura/emitir/${bussinesId}/${xUseDefaults}`
    return this.http.post(path, payload)
  }

  getEstadoLocal(documentId: string) {
    const path = `v1/factura/estado-local/${documentId}`
    // const path = `http://localhost:8000/v1/factura/estado-local/${documentId}`
    return this.http.get(path)
  }

  getDocumentoArchivos(documentId: string) {
    const path = `v1/factura/documento/${documentId}/archivos`
    return this.http.get(path)
  }

  crearCredenciales(bussinesId, payload) {
    console.log('emitirFactura', { bussinesId, payload })
    const path = `v1/factura/credencial/${bussinesId}`
    return this.http.post(path, payload)
  }

  getSearchEntityRut(rut) {
    const path = `v1/factura/entidad`
    return this.http.get(path, { params: { rut } })
  }

  getCredencials() {
    const path = `v1/factura/credenciales`
    return this.http.get(path)
  }

  getDocuments(params) {
    const queryString = Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== null && String(value) !== '')
      .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
      .join('&')
    const path = `v1/factura/documentos${queryString ? `?${queryString}` : ''}`
    return this.http.get(path)
  }

  getDocument(id) {
    const path = `v1/factura/documento/${id}`
    return this.http.get(path)
  }

  createBulkInvoiceUpload(businessId, payload) {
    const path = `v1/factura/bulk-upload/${businessId}`
    return this.http.post(path, payload)
  }

  getBulkInvoiceUploads(businessId) {
    const path = `v1/factura/bulk-upload/${businessId}`
    return this.http.get(path)
  }

  downloadExcelTemplate(type, currency, doc) {
    const path = `v1/factura/template?type=${type}&currency=${currency}&doc=${doc}`
    return this.http.get(path, { responseType: 'blob' })
  }

  getDocumentsProgramados(params) {
    const { page, page_size, master_entity_id } = params
    const path = `v1/factura/documentos-programados?page=${page}&page_size=${page_size}&master_entity_id=${master_entity_id}`
    return this.http.get(path)
  }

  crearDocumentosProgramados(bussinesId, masterEntityId, payload) {
    debugger
    const path = `v1/factura/documento-programado/${bussinesId}/${masterEntityId}`
    return this.http.post(path, payload)
  }

  updateDocumentosProgramados(id, masterEntityId, payload) {
    const path = `v1/factura/documento-programado/${id}/${masterEntityId}`
    return this.http.patch(path, payload)
  }

  getDocumentoProgramado(id, masterEntityId) {
    const path = `v1/factura/documento-programado/${id}/${masterEntityId}`
    return this.http.get(path)
  }

  deleteDocumentoProgramado(id, masterEntityId) {
    const path = `v1/factura/documento-programado/${id}/${masterEntityId}`
    return this.http.delete(path)
  }
}
